import { consultantSharedStyles, datePickerFieldStyles } from '../shared/styles';
import { adminPagesSharedStyles, BORDER, createAdminPageStyles, TEXT } from '../style';

export const useStyles = createAdminPageStyles({
  ...consultantSharedStyles,
  page: {
    ...adminPagesSharedStyles.page,
    background: '#EDEEF2',
  },
  body: {
    flex: 1,
    width: '50%',
  },
  bodyWide: {
    flex: 1,
    width: '100%',
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 16,
    '@media (max-width: 600px)': {
      gridTemplateColumns: '1fr',
    },
  },
  avatar: {
    ...consultantSharedStyles.avatar,
    borderRadius: 8,
  },
  textField: {
    ...adminPagesSharedStyles.textField,
    ...datePickerFieldStyles.textField,
  },
  datePickerBtn: datePickerFieldStyles.datePickerBtn,
  badges: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 6,
    marginTop: 6,
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 6,
    padding: '3px 8px',
    fontFamily: 'Poppins',
    fontSize: 12,
    fontWeight: 500,
  },
  addServiceBtn: {
    textTransform: 'none',
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: 13,
    color: TEXT,
    border: `1.5px solid ${BORDER}`,
    borderRadius: 8,
    background: '#FFFFFF',
    whiteSpace: 'nowrap',
    padding: '8px 12px',
  },
});
